export function loadUrlFile(url: string, title: string = 'Documento PDF cultura palenquera') {
  let btn = document.querySelector(`.trnz-popup__btn`) as HTMLButtonElement

  console.log('esta es la url:', url);

  if (url) {
      btn?.setAttribute('href', `${url}`)
      btn?.setAttribute('download', `${title}`)
  }

  if (title) {
      btn!.onclick = (e) => {
          window.dataLayer.push({
              'event': 'GAEvent',
              'event_category': 'Content',
              'event_action': 'button',
              'event_label': title.toLowerCase().split(' ').join('_') + '_Download-Complete',
              'interaction': 'true',
              'component_name': 'button_download', // example:button_seemore
              'element_text': 'download', // example: see more
          });
      }
  }
}

export function setAndGetCookie(key: string, value?: string): string {
  // Set Cookie Value
  if (value) document.cookie = `_${key}=${value}`

  // Get Cookie Value
  let cookies = document.cookie.split(';')
  let cookieFound = cookies.find((cookie: string) => cookie.split('=')[0].trim() == `_${key}`)

  if (cookieFound) return cookieFound.split('=')[1]
  return
}